export default "__VITE_ASSET__DK7AnG1S__"